import React, { useState } from "react";
import { Typography, Input, Tabs, Menu, Dropdown, Button, Icon } from "antd";
import LedgerTable from "./LedgerTable";

const { Title } = Typography;
const { Search } = Input;
const { TabPane } = Tabs;

const Ledger = () => {
  const [activeTab, setActiveTab] = useState("1");
  const [pageSize, setPageSize] = useState(10);
  const [searchString, setSearchString] = useState("");
  const [submittedSearch, setSubmittedSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState(0);

  // Tab change resets search and pagination
  const handleTabChange = (key) => {
    setActiveTab(key);
    setCurrentPage(1);
    setSearchString("");
    setSubmittedSearch("");
  };

  // Page size dropdown
  const menu = (
    <Menu onClick={(e) => setPageSize(Number(e.key))}>
      {[5, 10, 20, 50, 100].map((num) => (
        <Menu.Item key={num}>{num}</Menu.Item>
      ))}
    </Menu>
  );

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Title level={3} style={{ margin: 0 }}>
            Ledger [{count}]
          </Title>
          <Dropdown overlay={menu}>
            <Button>
              {pageSize} <Icon type="down" />
            </Button>
          </Dropdown>
        </div>

        <Search
          placeholder="Search..."
          value={searchString}
          onChange={(e) => setSearchString(e.target.value)}
          onSearch={(value) => {
            setSubmittedSearch(value);
            setCurrentPage(1);
          }}
          style={{ width: 300 }}
          allowClear
        />
      </div>

      {/* Tabs */}
      <Tabs activeKey={activeTab} onChange={handleTabChange}>
        {[
          { key: "1", label: "Bank Account", type: "BANK_ACCOUNT" },
          { key: "2", label: "Cash Account", type: "CASH_ACCOUNT" },
          { key: "3", label: "Customers", type: "CUSTOMERS" },
          { key: "4", label: "Employees", type: "EMPLOYEES" },
          { key: "6", label: "Pinelabs Account", type: "PINELABS_ACCOUNT"}
          // { key: "5", label: "Suppliers", type: "SUPPLIERS" },
        ].map(({ key, label, type }) => (
          <TabPane tab={label} key={key}>
            <LedgerTable
              type={type}
              pageSize={pageSize}
              searchString={submittedSearch}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              count={count}
              setCount={setCount}
              activeTab={activeTab}
            />
          </TabPane>
        ))}
      </Tabs>
    </div>
  );
};

export default Ledger;
